import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api/';

// Immediately set the header on file load if a token exists in storage
const initialToken = sessionStorage.getItem("token");
if (initialToken) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + initialToken;
}

const AuthProvider = ({ children }) => {
  // State to hold the authentication token
  const [token, setToken_] = useState(initialToken);

  // Function to set the authentication token
  const setToken = async (newToken) => {
    setToken_(newToken);

    // 2. Synchronously update storage and Axios headers to avoid page change lag
    if (newToken) {
      sessionStorage.setItem('token', newToken);
      axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;
    } else {
      sessionStorage.removeItem('token');
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  useEffect(() => { }, [token]);

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
    }),
    [token]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;